<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="状态">
        <Select
          placeholder="全部状态"
          v-model="searchCondition.is_release"
          style="width:200px"
          clearable
        >
          <Option v-for="item in statusList" :value="item.status" :key="item.status">{{ item.name }}</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Input
          style="width:200px"
          placeholder="请输入消息关键字"
          v-model="searchCondition.keywords"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" :to="{name: 'MessageEdit'}">新建消息</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/message"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" v-if="row.is_release==1" @click="open(row.id)">发布-</Button>
          <Button
            type="text"
            size="small"
            :to="{name: 'MessageEdit',query:{id:row.id}}"
            :disabled="row.is_release==2"
          >编辑</Button>-
          <Button
            type="text"
            size="small"
            @click="del('one',row.id)"
            :disabled="row.is_release==2"
          >删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "Message",
  data() {
    return {
      column: [
        {
          title: "消息标题",
          key: "title",
          minWidth: 140,
          align: "center"
        },
        {
          title: "发送对象",
          key: "group_title",
          minWidth: 120,
          align: "center"
        },
        {
          title: "发布状态",
          key: "status_value",
          minWidth: 100,
          align: "center"
        },
        {
          title: "发布人",
          key: "create_user",
          minWidth: 140,
          align: "center"
        },
        {
          title: "发布时间",
          key: "created_at",
          minWidth: 180,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 180,
          fixed: "right",
          align: "center"
        }
      ],
      selectList: [],
      searchCondition: {
        keywords_type: 1,
        keywords: "",
        is_release: ""
      },
      position_status: "",
      statusList: [{ status: 1, name: "未发布" }, { status: 2, name: "已发布" }]
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.status_value = i.is_release == 1 ? "未发布" : "已发布";
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
        this.searchCondition.is_release = "";
      }
      if (!this.searchCondition.is_release)
        this.searchCondition.is_release = "";
      this.$refs.grid.searchRefresh();
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个账号");
          return false;
        } else {
          let arr = [];
          this.selectList.forEach(i => {
            arr.push(i.uid);
          });
          ids = arr.join(",");
        }
      }
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该消息么？</p>",
        onOk: () => {
          this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    delete(_ids) {
      this.$http.delete(`/api/message/${_ids}`).then(() => {
        this.search(1);
      });
    },
    open(id) {
      this.$http.put(`/api/message/publish/${id}`).then(() => {
        this.$Message.success("发布成功");
        this.$refs.grid.refresh();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
